export default "__VITE_ASSET__CIQ_ff7$__"